import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hiddenField", "preview"]

  connect() {
  }

  remove(event) {
    const previewEl = event.currentTarget.closest("[data-uploaded-files-target='preview']")
    const signedIdToRemove = previewEl.dataset.id
    const isAttached = previewEl.dataset.attached === "true"

    // Rimuove dal DOM
    previewEl.remove()

    if (isAttached) {
      // Se il file è già salvato, rimuovilo via AJAX
      this.removeAttachedFile(signedIdToRemove)
    } else if (this.hasHiddenFieldTarget) {
      // Altrimenti aggiorna il campo hidden
      const currentIds = this.hiddenFieldTarget.value.split(',').filter(Boolean)
      const updatedIds = currentIds.filter(id => id !== signedIdToRemove)
      this.hiddenFieldTarget.value = updatedIds.join(',')
    }
  }

  removeAttachedFile(signedId) {
    // Modifica questo URL secondo la tua rotta Rails
    fetch(`/attachments/${signedId}`, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    }).then(response => {
      if (!response.ok) {
        console.error("Errore nella rimozione del file allegato")
      }
    })
  }
}
